module.exports = __webpack_public_path__ + "static/media/logo2.f2ef9a90.png";